import React, { useState } from 'react';
import { UserRound, Upload, Save } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export default function Perfil() {
  const { user } = useAuth();
  const [foto, setFoto] = useState(null);
  const [nome, setNome] = useState(user?.name || '');
  const [creci, setCreci] = useState('');
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState(user?.email || '');

  const handleFotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => setFoto(ev.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSave = () => {
    localStorage.setItem('tesiq_perfil', JSON.stringify({ nome, creci, telefone, email, foto }));
    toast.success('Perfil salvo! Suas informações aparecerão nos PDFs exportados.');
  };

  return (
    <div className="max-w-2xl mx-auto py-12 px-4">
      <div className="flex items-center gap-3 mb-6">
        <UserRound size={28} className="text-[#064E3B]" />
        <h1 className="text-2xl font-bold text-stone-900" style={{ fontFamily: 'Playfair Display, serif' }}>
          Perfil do Corretor
        </h1>
      </div>

      <div className="bg-white border border-stone-200 rounded-xl p-6 space-y-6">
        {/* Foto */}
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-full bg-[#064E3B] flex items-center justify-center overflow-hidden shrink-0">
            {foto
              ? <img src={foto} alt="Foto" className="w-full h-full object-cover" />
              : <span className="text-white text-2xl font-bold">{(nome || 'U').charAt(0).toUpperCase()}</span>
            }
          </div>
          <div>
            <label className="cursor-pointer inline-flex items-center gap-2 px-4 py-2 bg-stone-100 hover:bg-stone-200 text-stone-700 rounded-lg text-sm font-medium transition-colors">
              <Upload size={14} />
              Carregar foto
              <input type="file" accept="image/*" className="hidden" onChange={handleFotoChange} />
            </label>
            <p className="text-xs text-stone-500 mt-1">Aparecerá no cabeçalho dos PDFs exportados</p>
          </div>
        </div>

        {/* Campos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-1">
            <label className="text-xs font-semibold text-stone-600 uppercase tracking-wide">Nome completo</label>
            <input
              className="w-full h-10 border border-stone-200 rounded-lg px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#064E3B]/20"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
          </div>
          <div className="space-y-1">
            <label className="text-xs font-semibold text-stone-600 uppercase tracking-wide">CRECI</label>
            <input
              className="w-full h-10 border border-stone-200 rounded-lg px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#064E3B]/20"
              value={creci}
              onChange={(e) => setCreci(e.target.value)}
              placeholder="Ex: SC-12345"
            />
          </div>
          <div className="space-y-1">
            <label className="text-xs font-semibold text-stone-600 uppercase tracking-wide">Telefone / WhatsApp</label>
            <input
              className="w-full h-10 border border-stone-200 rounded-lg px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#064E3B]/20"
              value={telefone}
              onChange={(e) => setTelefone(e.target.value)}
              placeholder="(47) 99999-9999"
            />
          </div>
          <div className="space-y-1">
            <label className="text-xs font-semibold text-stone-600 uppercase tracking-wide">E-mail profissional</label>
            <input
              className="w-full h-10 border border-stone-200 rounded-lg px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#064E3B]/20"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>

        <div className="pt-2">
          <button
            onClick={handleSave}
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-[#064E3B] hover:bg-[#064E3B]/90 text-white rounded-lg text-sm font-semibold transition-colors"
          >
            <Save size={15} />
            Salvar perfil
          </button>
        </div>
      </div>
    </div>
  );
}
